import { AfterViewInit, Component, inject } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Meeting, RelatedMeeting } from '@app/core/model/entities/meeting/meeting';
import { MeetingsService } from '@app/features/main/views/meetings/meetings.services';
import {
  MatSelectEntityAutocomplete
} from '@app/shared/components/mat-select-autocomplete/mat-select-entity-autocomplete/mat-select-entity-autocomplete.component';
import { map, tap } from 'rxjs/operators';

@Component({
  selector: 'mat-select-meeting-autocomplete',
  styleUrls: ['../mat-select-entity-autocomplete.component.scss'],
  templateUrl: './mat-select-entity-autocomplete-client.component.html',
  providers: [
    {provide: MatFormFieldControl, useExisting: MatSelectMeetingAutocompleteComponent}
  ],
  standalone: false
})
export class MatSelectMeetingAutocompleteComponent extends MatSelectEntityAutocomplete<RelatedMeeting, Meeting> implements AfterViewInit {
  private meetingsService = inject(MeetingsService);

  /**
   * Load the Meetings to be displayed in the dropdown.
   */
  public ngAfterViewInit(): void {
    super.ngAfterViewInit();
    // Emits when the value of the input element changes.
    this.dataSourceInput$ = this.meetingsService.loadAllMeetings({}).pipe(
      map(relatedMeetings => relatedMeetings.map(meeting => meeting.toRelatedMeeting())),
      tap((relatedMeetings) => {
        this.hasData = relatedMeetings.length > 0;
        this.ready = true;
      })
    );
  }
}
